angular.module('gym.pos').factory('ProductCategories', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('pos').all('product_categories');
}]);
